// https://qiita.com/Evolutor_web/items/ffe5af0454f3743b4e43
export function isset(data){
  if(data === "" || data === null || data === undefined){
    return false;
  }else{
    return true;
  }
}